import { useState, useEffect } from 'react';
import { api, getCurrentLocale } from '../services/api';

export interface LooseTreatmentItem {
  id: number;
  name?: string;
  description?: string;
  price?: string;
}

export interface LooseTreatmentsCombined {
  title?: string;
  description?: string;
  items: LooseTreatmentItem[];
}

export const useLooseTreatments = () => {
  const [data, setData] = useState<LooseTreatmentsCombined | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch single type (section) and items separately; locale is auto-injected
        const [sectionRes, itemsRes] = await Promise.all([
          api.get('/loose-treatments-section?populate=*'),
          api.get('/loose-treatment-items?populate=*&sort=order:asc'),
        ]);

        const sectionRaw = sectionRes?.data?.data || {};
        const section = (sectionRaw && (sectionRaw as any).attributes) ? (sectionRaw as any).attributes : sectionRaw;

        const itemsRaw: any[] = Array.isArray(itemsRes?.data?.data) ? itemsRes.data.data : [];
        const items: LooseTreatmentItem[] = itemsRaw.map((it) => {
          const base = (it && (it as any).attributes) ? (it as any).attributes : it || {};
          return {
            id: it.id,
            name: base?.name,
            description: base?.description,
            price: base?.price,
          };
        });

        setData({
          title: section.title,
          description: section.description,
          items,
        });
      } catch (err: any) {
        if (err.response?.status !== 404) {
          console.log('Error fetching loose treatments:', err);
        }
        setError(err?.message || 'Failed to fetch loose treatments');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // re-fetch when locale changes
  }, [typeof window !== 'undefined' ? getCurrentLocale() : 'nl']);

  return { data, loading, error };
};